import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Row, Col, Spinner, Carousel } from 'react-bootstrap';
import { HRDashboardStyled, Icon, CustomGraph } from '../../components';
import { camelCaseEmptyStringRecursive } from '../../services/utils';
import { selectionProcessCardsRequest } from '../../requests/selectionProcesses';

const chunkInPairs = arr => {
  if (!Array.isArray(arr)) return [];
  const chunks = [];
  for (let i = 0; i < arr.length; i += 2) chunks.push(arr.slice(i, i + 2));
  return chunks;
};

const SelectionProcessDashboard = () => {
  const dispatch = useDispatch();

  const [cards, setCards] = useState({
    total: 0,
    active: 0,
    suspended: 0,
    deserted: 0,
    closed: 0,
    generated: 0,
    candidateBySelectionProcess: []
  });
  const [loading, setLoading] = useState(true);

  const fetchIndexCards = useCallback(() => {
    setLoading(true);
    selectionProcessCardsRequest({
      dispatch,
      successCallback: response => {
        setCards(camelCaseEmptyStringRecursive(response.data));
        setLoading(false);
      }
    });
  }, [dispatch]);

  useEffect(() => {
    fetchIndexCards();
  }, [fetchIndexCards]);

  const candidateBySelectionProcess = cards?.candidateBySelectionProcess || [];

  const graphPairs = useMemo(() => chunkInPairs(candidateBySelectionProcess), [candidateBySelectionProcess]);

  if (loading) {
    return (
      <div className="containerSpinnerLoad">
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <>
      <Row className="mt-4 mb-3">
        <Col md={12}>
          <Row className="mb-3">
            <Col md={3} xs={6}>
              <HRDashboardStyled
                title={cards.total}
                subtitle2="Procesos"
                TopHeaderColor="#fff"
                TypeCard="OnlyInformation"
                topHeight="15"
                CardName="Processes"
                onRequest={loading}
              />
            </Col>
            <Col md={3} xs={6}>
              <HRDashboardStyled
                title={cards.active}
                subtitle2="Activos"
                TopHeaderColor="#fff"
                GeneralColor="#2ecc71"
                TypeCard="OnlyInformation"
                topHeight="15"
                CardName="Active"
                onRequest={loading}
              />
            </Col>
            <Col md={3} xs={6}>
              <HRDashboardStyled
                title={cards.suspended}
                subtitle2="Suspendidos"
                TopHeaderColor="#fff"
                GeneralColor="#f39c12"
                TypeCard="OnlyInformation"
                topHeight="15"
                CardName="Suspended"
                onRequest={loading}
              />
            </Col>
            <Col md={3} xs={6}>
              <HRDashboardStyled
                title={cards.deserted}
                subtitle2="Desiertos"
                TopHeaderColor="#fff"
                GeneralColor="#f39c12"
                TypeCard="OnlyInformation"
                topHeight="15"
                CardName="Deserted"
                onRequest={loading}
              />
            </Col>
          </Row>

          <Row>
            <Col md={8} xs={12}>
              <h4 className="text-uppercase mb-3">Candidatos por Estado</h4>
              <div className="selection-charts-container">
                {graphPairs.length ? (
                  <Carousel
                    indicators={false}
                    interval={null}
                    fade
                    prevIcon={
                      graphPairs.length > 1 ? (
                        <Icon width={20} style={{ color: 'black' }} icon="chevron-back" />
                      ) : (
                        undefined
                      )
                    }
                    nextIcon={
                      graphPairs.length > 1 ? (
                        <Icon width={20} style={{ color: 'black' }} icon="chevron-forward" />
                      ) : (
                        undefined
                      )
                    }
                  >
                    {graphPairs.map((pair, slideIdx) => (
                      <Carousel.Item key={`candidate-graphs-slide-${pair.map(p => p.title).join('-') || slideIdx}`}>
                        <Row>
                          {pair.map(element => (
                            <Col
                              md={6}
                              xs={12}
                              key={`candidate-graph-${element.title || element.chart}`}
                              className="mb-3"
                            >
                              <CustomGraph
                                customtopHeight={300}
                                chartType={element.chart}
                                data={element.data}
                                title={element.title}
                                activeAnimation={false}
                              />
                            </Col>
                          ))}
                          {pair.length === 1 && <Col md={6} xs={12} />}
                        </Row>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                ) : (
                  <div className="containerSpinnerLoad">
                    <Spinner animation="border" variant="primary" />
                  </div>
                )}
              </div>
            </Col>

            <Col md={{ offset: 1, span: 3 }} xs={12} className="mt-4">
              <Row>
                <Col md={12} xs={4} className="mb-4">
                  <HRDashboardStyled
                    title={cards.closed}
                    subtitle2="Cerrados"
                    TopHeaderColor="#fff"
                    GeneralColor="#e74c3c"
                    TypeCard="OnlyInformation"
                    topHeight="15"
                    CardName="Closed"
                    onRequest={loading}
                  />
                </Col>
                <Col md={12} xs={4}>
                  <HRDashboardStyled
                    title={cards.generated}
                    subtitle2="Candidatos"
                    TopHeaderColor="#fff"
                    GeneralColor="#2ecc71"
                    TypeCard="OnlyInformation"
                    topHeight="15"
                    CardName="Generated"
                    onRequest={loading}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default SelectionProcessDashboard;
